import { render, staticRenderFns } from "./return-table.vue?vue&type=template&id=669e3194&scoped=true&"
import script from "./return-table.vue?vue&type=script&lang=js&"
export * from "./return-table.vue?vue&type=script&lang=js&"
import style0 from "./return-table.vue?vue&type=style&index=0&id=669e3194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e3194",
  null
  
)

export default component.exports